<template>
  <div class="park-moneylist">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <DatePicker
              type="daterange"
              format="yyyy-MM-dd"
              split-panels
              @on-change="changeDate"
              style="width: 200px"
              placeholder="开始时间 - 结束时间"
            ></DatePicker>
          </FormItem>
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入商家名称..."></Input>
          </FormItem>
          <!--<FormItem label="" prop="cateid">-->
          <!--<Select v-model="formItem.cate_id" :style="{'width':'240px'}">-->
          <!--<Option v-for="item in cateSelect" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
          <!--</Select>-->
          <!--</FormItem>-->
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Row>
      <Col :xs="8" :sm="8">
        <Alert>总收入：¥{{ total_price }}</Alert>
        <div style="float: left;"></div>
      </Col>
      <Col :xs="8" :sm="8">
        <Alert>园区收入：¥{{ park_total_price }}</Alert>
        <div style="float: left;"></div>
      </Col>
      <Col :xs="8" :sm="8">
        <Alert>平台服务费：¥{{ service_total_price }}</Alert>
        <div style="float: left;"></div>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- <Modal v-model="showModalStatus" title="收入记录" :loading="loading">
          <Form action="javascript:void(0)">
            <Table border :columns="columns" ref="selection" :data="tablelist1" :loading="dataloading"></Table>
          </Form>
    </Modal>-->
  </div>
</template>

<script>
export default {
  name: "park-moneylist",
  data() {
    return {
      tradesman: {},
      biliModel: {},
      loading: true,
      dataloading: true,
      biliStatus: false,
      title: "",
      park_total_price: "0.00",
      total_price: "0.00",
      service_total_price: "0.00",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      columns: {},
      list: [
        {
          title: "订单编号",
          key: "order_num",
          width: 200
        },
        {
          title: "收入来源",
          key: "income_sorce",
          width: 100
        },
        {
          title: "订单总金额",
          key: "total_prices",
          width: 100
        },
        {
          title: "商家名称",
          key: "name",
          width: 150
        },
        {
          title: "平台服务费",
          key: "firstname",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "分销比例：" + params.row.park_service_fx
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "分销金额：" + params.row.to_parkservice
              )
            ]);
          }
        },
        {
          title: "园区服务费",
          key: "firstname",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "分销比例：" + params.row.park_fx
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "分销金额：" + params.row.to_parktc
              )
            ]);
          }
        },
        {
          title: "一级分销名称",
          key: "firstname",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "店铺名：" +
                  (params.row.firstagent != null ? params.row.firstagent : "")
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "分销比例：" + params.row.to_first_agentfx
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "分销金额：" + params.row.to_firstagenttc
              )
            ]);
          }
        },
        {
          title: "二级分销名称",
          key: "agentname",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "店铺名：" +
                  (params.row.agentname != null ? params.row.agentname : "")
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "分销比例：" + params.row.to_agentfx
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "分销金额：" + params.row.to_agenttc
              )
            ]);
          }
        },
        {
          title: "商户收入",
          key: "tradesmanmoney",
          width: 100
        },
        {
          title: "订单状态",
          key: "order_status",
          width: 100
        },
        {
          title: "下单用户",
          key: "user",
          width: 150
        },
        {
          title: "下单时间",
          key: "order_time",
          width: 150
        },
        {
          title: "到账时间",
          key: "created_at",
          width: 150
        }
      ],
      tablelist: [],
      datetime: [],
      order_num: 0,
      showModalStatus: false,
      exportLoading: false
    };
  },
  created: function() {
    this.id = this.$route.params.id;
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.parkmoneylog
        .list({
          park_uuid: this.id,
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.park_total_price = res.result.park_total_price;
            this.total_price = res.result.total_price;
            this.service_total_price = res.result.service_total_price;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    changeDate(val) {
      this.datetime = val;
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      var starttime = this.datetime[0] != undefined ? this.datetime[0] : "";
      var endtime = this.datetime[1] != undefined ? this.datetime[1] : "";
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        park_uuid: this.id,
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        starttime: starttime,
        endtime: endtime
      };
      this.$api.parkmoneylog.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.park_total_price = res.result.park_total_price;
          this.total_price = res.result.total_price;
          this.service_total_price = res.result.service_total_price;
          this.pages.total = res.result.total;
        }
      });
      return;
    }
  }
};
</script>